import { render } from "./orderList.vue?vue&type=template&id=03046f38&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"

import "./orderList.vue?vue&type=style&index=0&id=03046f38&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03046f38"]])

export default __exports__